var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowLocationWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "19px",
    viewBox: "0 0 11 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icArrowLocation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.97590059,8.9490873 C9.99546151,9.25374208 9.88882533,9.56498418 9.65599205,9.79781746 L1.87781746,17.5759921 C1.44824074,18.0055688 0.751759262,18.0055688 0.322182541,17.5759921 C-0.10739418,17.1464153 -0.10739418,16.4499339 0.322182541,16.0203571 L7.39345238,8.9490873 L0.322182541,1.87781746 C-0.10739418,1.44824074 -0.10739418,0.751759262 0.322182541,0.322182541 C0.751759262,-0.10739418 1.44824074,-0.10739418 1.87781746,0.322182541 L9.65599205,8.10035713 C9.88882533,8.33319041 9.99546151,8.64443252 9.97590059,8.9490873 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(5.280000, 9.200000) scale(-1, 1) translate(-5.280000, -9.200000) translate(0.280000, 0.200000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icArrowLocation",
    fill: "#ffffff",
    fillRule: "nonzero",
    transform: "translate(4.989087, 8.949087) scale(-1, 1) translate(-4.989087, -8.949087) ",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowLocationWhite);
export default __webpack_public_path__ + "static/media/icArrowLocationWhite.8319fe8ffc58380867d63eff20464cb7.svg";
export { ForwardRef as ReactComponent };